module.exports = __webpack_public_path__ + "static/media/app-development.791cb76d.png";